import {FindCustomWorldResponse} from "../../../types/pj1dbApiWorld";
import useFetchAllQuery, {Status, useFetchAllQueryHelper} from "../../../hooks/useFetchAllQuery";
import {findCustomWorld} from "../../../utils/awsAmplifyUtil";

export interface UseCustomWorldByBaseWorldParams {
  baseWorldIds: string[];
  searchText?: string;
  onChange: (newData: FindCustomWorldResponse[], newStatus: Status) => void;
  enableAutoFetch?: boolean,
  initialStatus?: Status,
}

export function useCustomWorldByBaseWorld(params: UseCustomWorldByBaseWorldParams) {
  const result = useFetchAllQuery({
    queryFn: (query) => findCustomWorld({
      body: {
        'query-final': {
          'calc.base': {
            $in: params.baseWorldIds,
          },
          ...(
            params.searchText && params.searchText !== ''
              ? {
                'name-jp': {$regex: params.searchText, $options: 'i'},
              }
              : {}
          ),
        },
      },
      query
    }),
    needToFetchMore: (data, limit) => Object.entries(data?.items ?? {}).length === limit,
    enableAutoFetch: params.enableAutoFetch,
  });
  const helperResult = useFetchAllQueryHelper({
    onChange: params.onChange,
    data: result.data,
    status: result.status,
    initialStatus: params.initialStatus
  });

  return {
    ...result,
    ...helperResult,
  }
}
